export class ContactWithAuthorService {
  private static readonly serviceRoot = "/umbraco/api/ContactWithAuthor/";

  // Allowlist and sanitize only what the API expects
  private static toSafePayload(d: EmailData) {
    // Adjust keys to match your schema
    const pick = <T extends object, K extends keyof T>(obj: T, keys: K[]) =>
      keys.reduce((acc, k) => {
        if (k in obj) (acc as any)[k] = obj[k];
        return acc;
      }, {} as Pick<T, K>);

    // Example: keep only these fields and sanitize
    const allowed = pick(d as any, [
      "subject",
      "message",
      "senderEmail",
      "authorId",
    ]);
    const trim = (v?: string, max = 4000) =>
      typeof v === "string" ? v.replace(/[\r\n]/g, " ").slice(0, max) : v;

    return {
      authorId: (allowed as any).authorId,
      senderEmail: trim((allowed as any).senderEmail, 254),
      subject: trim((allowed as any).subject, 200),
      message: trim((allowed as any).message, 4000),
    };
  }

  static async sendToAuthor(emailData: EmailData): Promise<void> {
    const payload = ContactWithAuthorService.toSafePayload(emailData);

    const res = await fetch(`${this.serviceRoot}sentToAuthor`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      // If auth cookies are not required for this endpoint, change to "omit"
      credentials: "same-origin",
      referrerPolicy: "no-referrer",
      cache: "no-store",
    });

    if (!res.ok) {
      // Avoid leaking raw response bodies; use a generic message or a known-safe code
      let safeMessage = res.statusText || "Request failed";
      try {
        const ct = res.headers.get("Content-Type") || "";
        if (ct.includes("application/json")) {
          const data: any = await res.json();
          // If your API returns a safe error identifier (e.g., { code: "BadRequest" }), prefer that
          if (data && typeof data.code === "string") {
            safeMessage = `Error: ${data.code}`;
          }
        }
      } catch {
        // swallow parse errors
      }

      const err = new Error(safeMessage) as Error & { status?: number };
      err.status = res.status;
      throw err;
    }
  }
}
